const INITIAL_STATE = {
  user: JSON.parse(localStorage.getItem('user')) || {
    _id: '',
    name: '',
    mainDptName: '',
    departments: [],
    type: '',
    permissionsGroup: {
      _id: '',
      company: ''
    },
    company: {
      licenses: {
        user: 0,
        ipRecorder: 0
      }
    }
  },
  isFetching: false,
  authLoginSuccess: false,
  authLoginError: false,
  authLogoutSuccess: false,
  authLogoutError: false,
  errorContent: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'AUTHENTICATIONS_START_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'AUTHENTICATIONS_END_REQUEST':
      return {
        ...state,
        authLoginSuccess: false,
        authLogoutSuccess: false,
        isFetching: false
      };
    case 'AUTHENTICATIONS_LOGIN_SUCCESS': {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('session', payload.session);
      delete payload.token;
      delete payload.session;
      localStorage.setItem('user', JSON.stringify(payload));
      return {
        ...state,
        user: payload,
        authLoginSuccess: true,
        authLoginError: false,
        errorContent: ''
      };
    }
    case 'AUTHENTICATIONS_LOGIN_ERROR':
      return {
        ...state,
        authLoginSuccess: false,
        authLoginError: true,
        errorContent: payload
      };
    case 'AUTHENTICATIONS_LOGOUT_SUCCESS': {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return {
        ...state,
        user: {},
        authLogoutSuccess: false,
        authLogoutError: false,
        errorContent: ''
      };
    }
    case 'AUTHENTICATIONS_LOGOUT_ERROR': {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return {
        ...state,
        authLogoutSuccess: false,
        authLogoutError: true,
        errorContent: payload
      };
    }
    case 'AUTHENTICATIONS_UPDATE_SESSION': {
      localStorage.setItem('user', JSON.stringify(payload));
      return {
        ...state,
        user: payload ? { ...payload } : { ...state.user }
      };
    }
    default:
      return { ...state };
  }
};

export default reducer;
